<h2 class="section-title">Links to Other Resources</h2>
<div class="section-content">
  <app-links-grid
    id="connect-links-section"
    [links]="connectLinkItems"
  ></app-links-grid>
</div>
